import DocumentTitleRoute from './document-title-route';

export default DocumentTitleRoute;
